import { PetColorModel, IPetColorModel } from '@common/models/PetColorModel';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { ServiceHelper } from '../serviceHelper';
import { ServiceMethodOptions } from '../types';

export class PetColorService {
  private static baseUrl: string = '/api/petcolor';

  static tags = {
    upsertPetColor: 'upsertPetColor',
    deletePetColor: 'deletePetColor',
  };

  static upsertPetColor = (
    data: IPetColorModel,
    options?: ServiceMethodOptions,
  ): Promise<PetColorModel> => {
    return trackPromise(
      new Promise<IPetColorModel>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .post<IPetColorModel>(data)
          .then((response) => {
            ServiceHelper.showSuccess('Pet Color updated.', options);
            resolve(new PetColorModel(response));
          })
          .catch((err) => {
            ServiceHelper.showError('Failed to update Pet Color.', options);
            reject(err);
          });
      }),
      this.tags.upsertPetColor,
    );
  };

  static deletePetColor = (
    petColorId: number,
    options?: ServiceMethodOptions,
  ): Promise<boolean> => {
    return trackPromise(
      new Promise<boolean>((resolve, reject) => {
        http(`${this.baseUrl}/${petColorId}`)
          .delete()
          .then(() => {
            ServiceHelper.showSuccess('Pet Color has been deleted.', options);
            resolve(true);
          })
          .catch((err) => {
            ServiceHelper.showError('Failed to delete Pet Color.', options);
            reject(err);
          });
      }),
      this.tags.deletePetColor,
    );
  };
}
